import ImageConverter from "./ImageConverter";
import ImageGridConverter from "./ImageGridConverter";
import ImageSlideConverter from "./ImageSlideConverter";
import FileConverter from "./FileConverter";
import MapConverter from "./MapConverter"


class AttachmentConverter {
  static convertToHtml(content) {
    content = ImageConverter.toHtml(content);
    content = ImageGridConverter.toHtml(content);
    content = ImageSlideConverter.toHtml(content);
    content = FileConverter.toHtml(content);
    content = MapConverter.toHtml(content);
    return content
  }

  static convertToTistory(editor, e) {
    ImageConverter.toTistory(editor, e);
    ImageGridConverter.toTistory(editor, e);
    ImageSlideConverter.toTistory(editor, e);
    FileConverter.toTistory(editor, e);
    MapConverter.toTistory(editor, e);
  }
}

export default AttachmentConverter;
